import script from "./DateBox.vue?vue&type=script&setup=true&lang=js"
export * from "./DateBox.vue?vue&type=script&setup=true&lang=js"

import "./DateBox.vue?vue&type=style&index=0&id=d3fa2714&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3fa2714"]])

export default __exports__